import { fetchSubmodelElement, createSubmodelElementAtPath } from '../../services/DppManagerService';
import { technicalProperties_fieldData_installation, technicalProperties_fieldData_removal } from '../../sm-templates/TechnicalData';

// Helper function to extract the highest number from Installation/Removal idShorts
const getHighestNumber = (submodelElement, type) => {
  if (!submodelElement?.value || !Array.isArray(submodelElement.value)) {
    return 0;
  }

  const prefix = type === 'Installation' ? 'Installation_' : 'Removal_';
  const numbers = submodelElement.value
    .filter(item => item.idShort && item.idShort.startsWith(prefix))
    .map(item => {
      const match = item.idShort.match(/(\d+)$/);
      return match ? parseInt(match[1], 10) : 0;
    });

  return numbers.length > 0 ? Math.max(...numbers) : 0;
};

// Helper function to update the template JSON with form data and new number
const updateTemplateJson = (template, data, newNumber) => {
  const updatedTemplate = JSON.parse(JSON.stringify(template)); // Deep copy

  // Update idShort and displayName with new number
  const typePrefix = data.type === 'Installation' ? 'Installation' : 'Removal';
  updatedTemplate.idShort = `${typePrefix}_${newNumber}`;
  updatedTemplate.displayName = [
    { language: 'en', text: `${typePrefix} ${newNumber}` },
    { language: 'de', text: `${typePrefix === 'Installation' ? 'Einbau' : 'Ausbau'} ${newNumber}` }
  ];

  // Update values in the value array
  updatedTemplate.value.forEach(item => {
    if (item.idShort === 'BatteryVoltage') {
      item.value = data.BatteryVoltage ? data.BatteryVoltage.toString() : '';
    } else if (item.idShort === 'MeterReading') {
      item.value = data.MeterReading ? data.MeterReading.toString() : '';
    } else if (item.idShort === 'Date') {
      item.value = data.Date || new Date().toISOString().split('T')[0];
    }
  });

  return updatedTemplate;
};

const WaterMeterReadingsHandler = async ({ data, setError, setSuccess, smId }) => {
  try {

    if (!smId || !data || !data.type) {
      throw new Error('Submodel ID and data with type are required');
    }

    // Determine the path and template based on type
    const isInstallation = data.type === 'Installation';
    const idShortPath = isInstallation
      ? 'TechnicalProperties.FieldData.Installation'
      : 'TechnicalProperties.FieldData.Removal';
    const template = isInstallation
      ? technicalProperties_fieldData_installation
      : technicalProperties_fieldData_removal;

    // Fetch the current Installation or Removal submodel element
    const descriptor = { id: smId }; // Assuming descriptor format
    const submodelElement = await fetchSubmodelElement(descriptor, idShortPath);

    // Get the highest Installation/Removal number
    const highestNumber = getHighestNumber(submodelElement, data.type);
    const newNumber = highestNumber + 1;

    // Update the template JSON with form data and new number
    const payload = updateTemplateJson(template, data, newNumber);

    // Create the new submodel element at the specified path
    await createSubmodelElementAtPath(smId, idShortPath, payload);

    const successMessage = <>
        {'Aktion erfolgreich.'}{' '}
        <a className="alert-link" href="#" onClick={() => window.location.reload()}>
          {'Seite neu laden um Änderungen zu sehen'}
        </a>
    </>;
    setSuccess(successMessage);


  } catch (err) {
    console.error(`Failed to save ${data.type} reading:`, err);
    setError(err.message || `Failed to save ${data.type} reading.`);
  }
};

export default WaterMeterReadingsHandler;